import { GraphQLClient } from 'graphql-request';
import { OperatorInvestorGraphql, SavingError, UserRolesEnum } from 'src/types.d';
import { graphQLRequest } from '../graphQL/graphQLRequestModule';
import { getOperatorInvestorByEmail_viewAs } from '../graphQL/queries/operatorPortal/getOperatorInvestorByEmail_viewAs';
import { getOperatorInvestorByEmail } from '../graphQL/queries/operatorPortal/getOperatorInvestorByEmail';

export async function getOperatorInvestorByEmailService(
  token: string,
  client: GraphQLClient,
  operatorId: string,
  emailSearch: string,
  isFromViewAs?: boolean,
): Promise<OperatorInvestorGraphql | SavingError> {
  const query = isFromViewAs ? getOperatorInvestorByEmail_viewAs : getOperatorInvestorByEmail;

  const variables = {
    operatorId,
    emailSearch,
  };

  const res = await graphQLRequest(token, client, query, variables, UserRolesEnum.operator);

  return res?.findOperatorInvestorByEmail ? res.findOperatorInvestorByEmail : res;
}
